import { EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { Fragment } from '@atlaskit/editor-prosemirror/model';
import { convertMarkdownToProsemirror } from '@atlassian/ai-model-io/convert-markdown-to-prosemirror';
import { ErrorUtils } from '../utils/errors';
export function getPMFragmentWithFallback(_ref) {
  var markdown = _ref.markdown,
    schema = _ref.schema,
    source = _ref.source,
    fireAIAnalyticsEvent = _ref.fireAIAnalyticsEvent,
    idMap = _ref.idMap;
  try {
    var _convertMarkdownToPro = convertMarkdownToProsemirror({
        schema: schema,
        markdown: markdown,
        idMap: idMap,
        featureToggles: {
          markdownPlus: true,
          markdownPlusExtensions: true,
          markdownPlusPanels: true,
          markdownPlusDecisions: true
        }
      }),
      pmFragment = _convertMarkdownToPro.pmFragment,
      htmlConvertedToFallbackNodes = _convertMarkdownToPro.htmlConvertedToFallbackNodes,
      htmlConvertedToNodes = _convertMarkdownToPro.htmlConvertedToNodes;
    return {
      pmFragment: pmFragment,
      htmlConvertedToFallbackNodes: htmlConvertedToFallbackNodes,
      htmlConvertedToNodes: htmlConvertedToNodes,
      isTextFallbackUsed: false
    };
  } catch (error) {
    // When convertMarkdownToProsemirror a fragment
    // we log an analytics event to call out that markdown conversion has failed
    fireAIAnalyticsEvent({
      payload: {
        action: 'failed',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'markdownParser',
        attributes: {
          source: source,
          errorType: 'markdownParser',
          errorMessage: ErrorUtils.extractErrorMessage(error)
        },
        eventType: EVENT_TYPE.OPERATIONAL
      }
    });

    // Instead of erroring, we fallback to rendering as plaintext in a single paragraph.
    var fallbackPMFragment = Fragment.from(schema.nodes.paragraph.create(null, schema.text(markdown)));
    return {
      pmFragment: fallbackPMFragment,
      htmlConvertedToFallbackNodes: 0,
      htmlConvertedToNodes: 0,
      isTextFallbackUsed: true
    };
  }
}